import { render, staticRenderFns } from "./emptyDomains.vue?vue&type=template&id=bb99a03c&scoped=true"
import script from "./emptyDomains.vue?vue&type=script&lang=js"
export * from "./emptyDomains.vue?vue&type=script&lang=js"
import style0 from "./emptyDomains.vue?vue&type=style&index=0&id=bb99a03c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb99a03c",
  null
  
)

export default component.exports